import { Component, OnInit } from '@angular/core';
import {
    AlertModule,
    AlertService,
    ButtonModule,
    ButtonTypes,
    ButtonColors,
    DropdownMenuItem,
    LayerService,
    LayerSize,
    PopupModule,
    PopupService,
    PopupTypes,
} from '@ed---interne/ng-uui-components';
import { SimulationExistingNetworkService } from '../../simulation-existing-network.service';

@Component({
    selector: 'app-simulate-existing-network',
    standalone: true,
    imports: [],
    templateUrl: './simulate-existing-network.component.html',
    styleUrl: './simulate-existing-network.component.scss',
})
export class SimulateExistingNetworkComponent {
    public buttonColors = ButtonColors;
    public buttonTypes = ButtonTypes;

    public loading = true;
    public isSimulated = false;

    constructor(
        private simulationService: SimulationExistingNetworkService,
        private readonly layerService: LayerService,
        private readonly alertService: AlertService,
    ) {}

    ngOnInit(): void {
        this.startSimulation();
    }

    async startSimulation() {
        try {
            await this.simulationService.simulateExistingNetwork();
        } catch (err: any) {
            const error = err.message || 'Erreur lors de la simulation';
            console.error('Error startSimulation', error);
            this.alertService.error('Simulation', 'Erreur lors de la simulation');
            this.layerService.close();
        } finally {
            this.loading = false;
            this.isSimulated = true;
        }
    }

    resetSimulation() {
        this.simulationService.resetSimulation();
        this.layerService.close();
    }

    clearXlsxFile() {
        this.simulationService.clearXlsxFile();
        this.layerService.close();
    }
}
